import type {
  ConversationCallAvailability,
  ConversationCallCard
} from '@paction-2.0/util/constants/conversationCalls';

import { api } from '../apiClient';

export type VideoCallJoin = {
  call: ConversationCallCard;
  conversationId: number;
  otherName: string;
  join: { token: string; serverUrl: string; roomName: string };
};

export const getConversationCallAvailability = (conversationId: number) =>
  api.get<undefined, ConversationCallAvailability>(
    `/me/calls/conversations/${conversationId}/availability`
  );

export const startConversationPhoneCall = (conversationId: number) =>
  api.post<undefined, { call: ConversationCallCard }>(
    `/me/calls/conversations/${conversationId}/phone`
  );

export const joinVideoCall = (callId: number) =>
  api.post<undefined, VideoCallJoin>(`/me/calls/${callId}/video-join`);

export const endVideoCall = (callId: number) =>
  api.post<undefined, { call: ConversationCallCard }>(
    `/me/calls/${callId}/end`
  );
